<template>
  <div class="flex flex-col flex-grow">
    <div class="mt-6">
      <div v-if="!stagesix && !stageloading" class="flex flex-col justify-center items-center">
        <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.6">
            <circle cx="34" cy="34" r="34" fill="#828282"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5625 33.9998L29.5309 42.9645L47.4603 25.0352" fill="#828282"/>
            <path d="M20.5625 33.9998L29.5309 42.9645L47.4603 25.0352" stroke="white" stroke-width="5.66667" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
        </svg>
        <p class="w-[210px] mt-4 font-Rubik text-[13px] leading-[20px] text-greyText text-center">No data exist for this stage</p>
      </div>
      <div v-if="!stagesix && stageloading">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: rgb(241, 242, 243); display: block; shape-rendering: auto;" width="100px" height="100px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
          <g transform="translate(26.666666666666668,26.666666666666668)">
            <rect x="-20" y="-20" width="40" height="40" fill="#000000">
              <animateTransform attributeName="transform" type="scale" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="1.1500000000000001;1" begin="-0.3s"></animateTransform>
            </rect>
          </g>
          <g transform="translate(73.33333333333333,26.666666666666668)">
            <rect x="-20" y="-20" width="40" height="40" fill="#636363">
              <animateTransform attributeName="transform" type="scale" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="1.1500000000000001;1" begin="-0.2s"></animateTransform>
            </rect>
          </g>
          <g transform="translate(26.666666666666668,73.33333333333333)">
            <rect x="-20" y="-20" width="40" height="40" fill="#e1e1e1">
              <animateTransform attributeName="transform" type="scale" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="1.1500000000000001;1" begin="0s"></animateTransform>
            </rect>
          </g>
          <g transform="translate(73.33333333333333,73.33333333333333)">
            <rect x="-20" y="-20" width="40" height="40" fill="#545454">
              <animateTransform attributeName="transform" type="scale" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="1.1500000000000001;1" begin="-0.1s"></animateTransform>
            </rect>
          </g>
        </svg>
      </div>
      <div v-if="stagesix">
        <div class="grid grid-cols-1 gap-4 mb-4">
          <div class="left">
            <div class="relative w-full mb-6">
              <label
                class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal mb-6"
                for="regulating-agencies"
              >
                List of product/service regulating agencies (If applicable)
              </label>
              <span v-if="stagesix.has_service_regulations === 'Yes'">
                <div class="relative">
                  <input
                    v-for="(serviceRegulation, index) in stagesix.service_regulations" :key="index"
                    id="service-regulations"
                    name="service-regulations"
                    type="text"
                    readonly
                    class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik bg-faintGrey placeholder-black text-black text-sm w-full border-none focus:outline-none focus:ring-0"
                    placeholder=""
                    style="transition: 'all .15s ease'"
                    :value="serviceRegulation"
                  />
                </div>
              </span>
            </div>
            <div class="relative w-full mb-6">
              <label
                class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal mb-6"
                for="pending-regulations"
              >
                List of past or pending regulatory investigations (If applicable)
              </label>
              <span v-if="stagesix.has_pending_regulations === 'Yes'">
                <input
                  v-for="(pendingRegulation, index) in stagesix.pending_regulations" :key="index"
                  id="pending-regulations"
                  name="pending-regulations"
                  type="text"
                  readonly
                  class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik bg-faintGrey placeholder-black text-black text-sm w-full border-none focus:outline-none focus:ring-0"
                  placeholder="Enter a regulation"
                  style="transition: 'all .15s ease'"
                  :value="pendingRegulation"
                />
              </span>
            </div>
            <div class="relative w-full mb-6">
              <label
                class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
              >
                Company compliance policy?
              </label>
              <span v-if="stagesix.has_compliance_policy === 'Yes'">
                <div class="relative w-full mt-2 mb-4">
                  <a v-if="Helpers.getFileExtension(stagesix.compliance_policy)"
                    class="flex items-center border border-black rounded text-xs leading-[15.41px] font-medium font-Rubik px-5 py-3 max-w-[max-content]"
                    :href="`https://view.officeapps.live.com/op/view.aspx?src=${s3Bucket}${stagesix.compliance_policy}`"
                    :download="`${stagesix.compliance_policy}`"
                    target="_blank"
                  >
                    <svg
                      class="h-4 w-4 text-black"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"/>
                    </svg>
                    <span class="ml-2">Download Compliance Policy</span>
                  </a>
                  <a v-else
                    class="flex items-center border border-black rounded text-xs leading-[15.41px] font-medium font-Rubik px-5 py-3 max-w-[max-content]"
                    :href="`${s3Bucket}${stagesix.compliance_policy}`"
                    :download="`${stagesix.compliance_policy}`"
                    target="_blank"
                  >
                    <svg
                      class="h-4 w-4 text-black"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"/>
                    </svg>
                    <span class="ml-2">Download Compliance Policy</span>
                  </a>
                </div>
              </span>
              <span v-else class="block">
                N/A
              </span>
            </div>
          </div>
          <div class="right">
            <div class="relative w-full mb-6">
              <label
                class="flex justify-between font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal mb-2"
              >
                Company code of conduct (If available)
              </label>
              <span v-if="stagesix.has_code_of_conduct === 'Yes'">
                <div class="relative w-full mt-2 mb-4">
                  <a v-if="Helpers.getFileExtension(stagesix.code_of_conduct)"
                    class="flex items-center border border-black rounded text-xs leading-[15.41px] font-medium font-Rubik px-5 py-3 max-w-[max-content]"
                    :href="`https://view.officeapps.live.com/op/view.aspx?src=${s3Bucket}${stagesix.code_of_conduct}`"
                    :download="`${stagesix.code_of_conduct}`"
                    target="_blank"
                  >
                    <svg
                      class="h-4 w-4 text-black"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"/>
                    </svg>
                    <span class="ml-2">Download Company code of conduct</span>
                  </a>
                  <a v-else
                    class="flex items-center border border-black rounded text-xs leading-[15.41px] font-medium font-Rubik px-5 py-3 max-w-[max-content]"
                    :href="`${s3Bucket}${stagesix.code_of_conduct}`"
                    :download="`${stagesix.code_of_conduct}`"
                    target="_blank"
                  >
                    <svg
                      class="h-4 w-4 text-black"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"/>
                    </svg>
                    <span class="ml-2">Download Company code of conduct</span>
                  </a>
                </div>
              </span>
              <span v-else>
                N/A
              </span>
            </div>
            <div class="relative w-full mb-28">
              <label
                class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                for="product-regulations"
              >
                List of mandatory product regulations and directives (If available)
              </label>
              <span v-if="stagesix.has_product_regulations === 'Yes'">
                <div class="relative" v-for="(productRegulation, index) in stagesix.product_regulations" :key="index">
                  <input
                    id="product-regulations"
                    name="product-regulations"
                    type="text"
                    readonly
                    class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik bg-faintGrey placeholder-black text-black text-sm w-full border-none focus:outline-none focus:ring-0"
                    placeholder="Enter a regulation"
                    style="transition: 'all .15s ease'"
                    :value="productRegulation"
                  />
                </div>
              </span>
              <span v-else class="block">
                N/A
              </span>
            </div>
          </div>
        </div>

        <div class="relative grid grid-cols-2">
          <div class="left">
            <div class="relative flex w-full mb-6">
             <button
              :disabled="company.progress.stage_six === 'Rejected' || company.progress.stage_six === 'Approved'"
              @click.prevent="openModal"
              class="flex items-center border text-originsRed border-originsRed rounded text-xs leading-[15.41px] font-medium font-Rubik px-12 py-3 disabled:opacity-50">
               Reject
             </button>
           </div>
          </div>
          <div class="right">
            <div class="relative flex justify-end w-full mb-6">
             <button
              :disabled="company.progress.stage_six === 'Rejected' || company.progress.stage_six === 'Approved'"
              class="flex items-center  text-white bg-originsGreen rounded text-xs leading-[15.41px] font-medium font-Rubik px-12 py-3 disabled:opacity-50"
              @click.prevent="confirmUpgrade = !confirmUpgrade">
               Upgrade
             </button>
           </div>
          </div>
        </div>
      </div>
    </div>

    <Modal v-show="data.modalOpen">
      <div class="bg-white rounded-[2px] py-[40px] px-[48px] relative">
        <template v-if="!data.rejected">
          <button @click.prevent="closeModal" class="close absolute right-[20px] top-[20px]">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#0D0D0D"/>
          </svg>
          </button>
          <h3 class="font-medium font-Rubik leading-[18.96px] text-black mb-[8px]">
            Why was this deal rejected?
          </h3>
          <hr />
          <div class="role mt-6 mb-6">
            <label
              class="
                font-Rubik
                text-greyText text-[11px]
                leading-[13.04px]
                font-normal
              "
              for="rejection_reason"
            >
              Give your reason(s)
            </label>

            <div class="relative">
              <textarea
                id="rejection_reason"
                name="rejection_reason"
                type="text"
                rows="4"
                class="
                  px-4
                  py-4
                  mt-2
                  text-[15px]
                  leading-[17.78px]
                  font-Rubik
                  placeholder-gray-400
                  text-black text-sm
                  border border-gray-200
                  w-full
                  focus:outline-none focus:border-black
                  hover:border-black
                  focus:ring-0
                  rounded-[2px]
                "
                placeholder=""
                style="transition: 'all .15s ease'"
                v-model="data.rejected_reason"
              />
              <div class="flex items-center font-Rubik">
                <span class="mr-[4px]">
                  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2637_9558)">
                      <path d="M3.48337 2.02919C3.48337 1.9377 3.5105 1.84827 3.56133 1.7722C3.61216 1.69613 3.6844 1.63684 3.76893 1.60183C3.85346 1.56682 3.94646 1.55766 4.0362 1.5755C4.12593 1.59335 4.20835 1.63741 4.27304 1.7021C4.33774 1.76679 4.38179 1.84922 4.39964 1.93895C4.41749 2.02868 4.40833 2.12169 4.37332 2.20621C4.33831 2.29074 4.27902 2.36298 4.20295 2.41381C4.12687 2.46464 4.03744 2.49177 3.94595 2.49177C3.82327 2.49177 3.70561 2.44304 3.61886 2.35629C3.53211 2.26954 3.48337 2.15188 3.48337 2.02919ZM4.66927 5.97499C4.53837 5.93304 4.37837 5.80994 4.37837 5.45894V3.15449C4.37837 3.1463 4.37677 3.1382 4.37364 3.13063C4.37052 3.12307 4.36593 3.11619 4.36015 3.1104C4.35436 3.10461 4.3475 3.10001 4.33994 3.09687C4.33238 3.09373 4.32427 3.09211 4.31609 3.09211H3.39748C3.36673 3.09211 3.33629 3.09818 3.30788 3.10995C3.27948 3.12172 3.25367 3.13898 3.23193 3.16072C3.2102 3.18247 3.19296 3.20829 3.1812 3.2367C3.16944 3.26511 3.16339 3.29555 3.1634 3.3263C3.16382 3.37663 3.18028 3.4255 3.21038 3.46583C3.24048 3.50616 3.28266 3.53584 3.33078 3.55056C3.46168 3.59251 3.62169 3.71561 3.62169 4.0666V5.45894C3.62169 5.80994 3.46169 5.93303 3.33074 5.97499C3.28261 5.98971 3.24043 6.01939 3.21033 6.05972C3.18022 6.10004 3.16377 6.14892 3.16334 6.19925C3.16334 6.26134 3.18801 6.3209 3.23192 6.3648C3.27583 6.40871 3.33538 6.43338 3.39748 6.43338H4.60252C4.66462 6.43338 4.72417 6.40871 4.76808 6.3648C4.81199 6.3209 4.83666 6.26134 4.83666 6.19925C4.83624 6.14892 4.81978 6.10004 4.78967 6.05972C4.75957 6.01939 4.71739 5.98971 4.66927 5.97499ZM8 4C8 4.79113 7.76541 5.56449 7.32588 6.22228C6.88636 6.88008 6.26164 7.39277 5.53074 7.69552C4.79983 7.99827 3.99556 8.07748 3.21964 7.92314C2.44372 7.7688 1.73098 7.38784 1.17157 6.82843C0.612165 6.26902 0.231202 5.55629 0.0768607 4.78036C-0.0774802 4.00444 0.00173316 3.20017 0.304484 2.46927C0.607234 1.73836 1.11992 1.11365 1.77772 0.674121C2.43552 0.234596 3.20888 0 4 0C5.0605 0.00119446 6.07722 0.423005 6.82711 1.17289C7.577 1.92278 7.99881 2.9395 8 4ZM7.64445 4C7.64445 3.2792 7.4307 2.57458 7.03025 1.97526C6.62979 1.37593 6.06061 0.908812 5.39467 0.632972C4.72873 0.357133 3.99596 0.284961 3.28901 0.425583C2.58205 0.566204 1.93268 0.913304 1.42299 1.42299C0.913306 1.93267 0.566206 2.58205 0.425584 3.289C0.284963 3.99596 0.357135 4.72873 0.632974 5.39467C0.908814 6.0606 1.37593 6.62979 1.97526 7.03025C2.57458 7.4307 3.2792 7.64444 4 7.64444C4.96623 7.64335 5.89258 7.25903 6.57581 6.5758C7.25903 5.89257 7.64335 4.96623 7.64445 4Z" fill="#828282"/>
                      <circle cx="4" cy="4" r="3.72" stroke="#828282" stroke-width="0.56"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_2637_9558">
                        <rect width="8" height="8" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                <span class="font-light text-[10px] text-greyText">Your reason will be sent to the user’s email so they know why their application was rejected.</span>
              </div>
            </div>
          </div>
          <div class="w-full flex items-center justify-end">
            <button :disabled="!data.rejected_reason" @click="rejectCompany" class="mt-3 flex bg-black text-white rounded-[2px] text-[16px] font-Rubik px-8 py-4 outline-none focus:outline-none disabled:opacity-50">
              <span :class="loading ? 'mr-2' : 'mr-0'" class="text-white">Submit</span>
              <svg v-if="loading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="20px" height="20px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#ffffff" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                  <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                </circle>
              </svg>
            </button>
          </div>
        </template>
        <template v-else>
          <div class="flex flex-col items-center justify-center">
            <h3 class="font-medium font-Rubik text-[16px] leading-[18.96px] text-black mb-[8px]">
              Sent!
            </h3>
            <p class="font-Rubik text-[15px] leading-[24px] text-center text-greyText max-w-[90%] mx-auto">Your comment has been sent to the user’s email address.</p>
            <button @click.prevent="closeModal" class="mt-6 border-b border-teal font-medium py-[12px] px-[35px] text-white text-[13px] leading-[15.41px] rounded-[4px] bg-black">Okay</button>
          </div>
        </template>
      </div>
    </Modal>
    <Modal v-show="confirmUpgrade === true">
        <div class="bg-white w-[399px] rounded-[6px] p-6 relative">
          <span class="block w-[48px] h-[48px] mb-[12px] mx-auto">
            <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 28C4 14.7452 14.7452 4 28 4C41.2548 4 52 14.7452 52 28C52 41.2548 41.2548 52 28 52C14.7452 52 4 41.2548 4 28Z" fill="#FEE4E2"/>
              <path d="M28 24V28M28 32H28.01M38 28C38 33.5228 33.5228 38 28 38C22.4772 38 18 33.5228 18 28C18 22.4772 22.4772 18 28 18C33.5228 18 38 22.4772 38 28Z" stroke="#D92D20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M28 48C16.9543 48 8 39.0457 8 28H0C0 43.464 12.536 56 28 56V48ZM48 28C48 39.0457 39.0457 48 28 48V56C43.464 56 56 43.464 56 28H48ZM28 8C39.0457 8 48 16.9543 48 28H56C56 12.536 43.464 0 28 0V8ZM28 0C12.536 0 0 12.536 0 28H8C8 16.9543 16.9543 8 28 8V0Z" fill="#FEF3F2"/>
            </svg>
          </span>
          <div class="flex flex-col items-start justify-center">
            <h3 class="font-medium font-Rubik text-[18px] leading-[24px] text-black mb-[12px] text-center w-full">
              Upgrade
            </h3>
            <p class="font-Rubik text-[13px] leading-[20px] text-greyText max-w-[95%] text-center w-full"> Are you sure you want to upgrade this company? </p>
            <div class="flex items-center justify-between w-full">
              <button @click="confirmUpgrade = false" class="font-Rubik mt-6 border-b border-teal font-medium py-[12px] px-[45px] text-[13px] text-black leading-[15.41px] rounded-[6px] mr-[24px] border-[0.6px] border-lineGray max-w-[170px] w-[50%]">Cancel</button>
              <button @click="upgradeCompany" class="font-Rubik mt-6 border-b border-teal font-medium py-[12px] px-[45px] text-white text-[13px] leading-[15.41px] rounded-[6px] bg-originsGreen max-w-[170px] w-[50%]">Upgrade</button>
            </div>
          </div>
        </div>
    </Modal>
  </div>
</template>

<script>
import { ref, reactive, computed } from 'vue'
import Modal from '@/components/Modal.vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import StageSixService from '@/services/stagesix.service'
import Helpers from '@/utils/helpers'
import CompanyService from '@/services/company.service'
const current = 2
export default {
  components: {
    Modal
  },
  setup () {
    const progress = reactive({
      stage1: true,
      stage2: false,
      stage3: true
    })
    const disabled = reactive({
      stage1: true,
      stage2: false,
      stage3: true
    })

    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const stageloading = ref(false)
    const loading = ref(false)
    const loading2 = ref(false)
    const company = computed(() => store.state.app.current_company)
    const stagesix = ref(null)
    const enabled = ref(false)
    const s3Bucket = process.env.VUE_APP_ORIGINS_S3_BUCKET

    const data = reactive({
      modalOpen: false,
      rejected: false,
      rejected_reason: ''
    })

    const openModal = () => {
      data.modalOpen = !data.modalOpen
    }
    const closeModal = () => {
      data.modalOpen = false
      data.rejected = false
      confirmUpgrade.value = false
    }

    const getStageSix = async () => {
      try {
        stageloading.value = true
        const id = route.params.id
        const response = await StageSixService.getStageSix(id)
        if (response.status === 200 && response.data.status === 'success') {
          stageloading.value = false
          stagesix.value = response.data.data
        }
      } catch (e) {
        stageloading.value = false
        Helpers.processError(e, store, router)
      }
    }
    getStageSix()

    const confirmUpgrade = ref(false)

    const upgradeCompany = async () => {
      if (confirmUpgrade.value === true) {
        try {
          loading.value = true
          const id = route.params.id
          const data = {
            company_id: id,
            user_id: company.value.user_id,
            current_stage: Helpers.getCurrentStage(company.value.current_stage),
            next_stage: 'stage_seven',
            // deal_lead: company.value.deal_lead,
            stage_name: Helpers.getCurrentStageName(company.value.current_stage),
            next_stage_name: Helpers.getCurrentStageName(company.value.next_stage)
          }
          const response = await CompanyService.approveCompany(data)
          if (response.status === 200 && response.data.status === 'success') {
            loading.value = false
            closeModal()
            Helpers.processDiligenceSuccess(response, store, 'Company upgraded successfully')
          }
        } catch (e) {
          loading.value = false
          closeModal()
          Helpers.processError(e, store, router)
        }
      } else {
        closeModal()
      }
    }

    const rejectCompany = async () => {
      try {
        loading2.value = true
        const id = route.params.id
        const rejectiondata = {
          company_id: id,
          user_id: company.value.user_id,
          current_stage: Helpers.getCurrentStage(company.value.current_stage),
          next_stage: 'stage_seven',
          // deal_lead: company.value.deal_lead,
          stage_name: Helpers.getCurrentStageName(company.value.current_stage),
          next_stage_name: Helpers.getCurrentStageName(company.value.next_stage),
          message: data.rejected_reason
        }
        const response = await CompanyService.rejectCompany(rejectiondata)
        if (response.status === 200 && response.data.status === 'success') {
          loading2.value = false
          Helpers.processDiligenceSuccess(response, store, 'Company rejected successfully')
          closeModal()
        }
      } catch (e) {
        closeModal()
        loading2.value = false
        Helpers.processError(e, store, router)
      }
    }

    return {
      current,
      progress,
      disabled,
      enabled,
      data,
      openModal,
      closeModal,
      route,
      stageloading,
      loading,
      loading2,
      company,
      stagesix,
      s3Bucket,
      confirmUpgrade,
      upgradeCompany,
      rejectCompany,
      Helpers
    }
  }
}
</script>
